<template>
    <div>
        <app-header />
        <app-main />
        <app-footer />
    </div>
</template>

<script>
import { AppMain, AppHeader, AppFooter } from './components'

export default {
    name: 'Layout',
    components: {
        AppMain,
        AppHeader,
        AppFooter
    }
}
</script>